(function () {
  angular.module("akitabox.mobile").run(routeBlock);

  /* @ngInject */
  function routeBlock(
    /* Angular */
    $rootScope,
    $location,
    $timeout,
    $window,
    /* Third-party */
    $state,
    /* Services */
    Router,
    AuthService,
    BuildingService,
    FilterService,
    HistoryService,
    OrganizationService,
    RedirectService,
    ToastService,
    ShadowService,
    UserService,
    FeatureFlagService,
    EnvService
  ) {
    Router.configureStates(getStates(), otherwise);

    var removeOnStateChangeStart = $rootScope.$on(
      "$stateChangeStart",
      onStateChangeStart
    );
    var removeOnStateChangeError = $rootScope.$on(
      "$stateChangeError",
      onStateChangeError
    );
    var removeOnStateChangeSucccess = $rootScope.$on(
      "$stateChangeSuccess",
      onStateChangeSuccess
    );
    var removeOnlocationChangeSucccess = $rootScope.$on(
      "$locationChangeSuccess",
      onLocationChangeSuccess
    );

    // Remove $rootScope listeners
    $rootScope.$on("$destroy", removeOnStateChangeStart);
    $rootScope.$on("$destroy", removeOnStateChangeError);
    $rootScope.$on("$destroy", removeOnStateChangeSucccess);
    $rootScope.$on("$destroy", removeOnlocationChangeSucccess);

    function otherwise() {
      RedirectService.findRedirect($location.url()).then(function (
        redirectRoute
      ) {
        if (redirectRoute) {
          return RedirectService.redirectTo(redirectRoute);
        }
        AuthService.isAuthenticated().then((authenticated) => {
          if (authenticated) return $state.go("root.404");
          // else redirect to login if there is no user
          // otherwise only certain routes will redirect to login when API calls are made
          // eslint-disable-next-line
          const qs = new URLSearchParams($location.search()).toString();
          let redirect_url = `${$location.protocol()}://${$location.host()}${$location.path()}${
            qs ? `?${qs}` : ""
          }`;
          if (
            redirect_url === `${EnvService.getBaseUrl()}/` ||
            $location.host().startsWith(`home.`)
          ) {
            redirect_url = "";
          }

          if (FeatureFlagService.isEnabled("customer_accounts_in_identities")) {
            $window.location.href = `${EnvService.getBaseUrl()}/logout${
              redirect_url ? `?redirect_url=${redirect_url}` : ""
            }`;
          } else {
            $state.go("auth.login", { redirect_url });
          }
        });
      });
    }

    function onLocationChangeSuccess($event, newUrl) {
      ShadowService.onLocationChange(newUrl);
    }

    function onStateChangeStart($event, toState) {
      showProgressBar();
      var path = $location.path();
      AuthService.isAuthenticated().then((authenticated) => {
        // Check if there is an authenticated user
        if (authenticated) {
          if (toState.name === "auth.login") {
            $event.preventDefault();
            return $state.go("app.dashboard");
          }
        } else if (path === "/" && toState.name !== "auth.login") {
          $event.preventDefault();
          // Otherwise redirect to the login page
          return $state.go("auth.login", {
            redirect_url: $location.url(),
          });
        }
      });
    }

    function onStateChangeError(
      $event,
      toState,
      toParams,
      fromState,
      fromParams,
      error
    ) {
      $event.preventDefault();
      ToastService.showError(error);
      hideProgressBar();

      // Handle 404 Errors
      if (error && error.status === 404) {
        return $state.go("root.404", null, { location: $location.url() });
      } else if (error && error.status === 401) {
        // they aren't logged in, redirect to login
        const qs = new URLSearchParams($location.search()).toString();
        let redirect_url = `${$location.protocol()}://${$location.host()}${$location.path()}${
          qs ? `?${qs}` : ""
        }`;
        if (
          redirect_url === `${EnvService.getBaseUrl()}/` ||
          $location.host().startsWith(`home.`)
        ) {
          redirect_url = "";
        }

        if (FeatureFlagService.isEnabled("customer_accounts_in_identities")) {
          $window.location.href = `${EnvService.getBaseUrl()}/logout${
            redirect_url ? `?redirect_url=${redirect_url}` : ""
          }`;
        } else {
          $state.go("auth.login", { redirect_url });
        }
      }

      // If not currently on a state, go to the dashboard
      if (angular.isEmpty($state.current.name)) $state.go("app.dashboard");
    }

    function onStateChangeSuccess(
      $event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      var building;
      var organization;

      HistoryService.push(fromState, fromParams);

      var titles = [];
      var pageTitle;
      if (toState.data && toState.data.pageTitle) {
        pageTitle = toState.data.pageTitle;
        titles.push(pageTitle);
      }
      titles.push("AkitaBox");
      $rootScope.pageTitle = titles.join(" | ");

      building = BuildingService.getCurrent();
      organization = OrganizationService.getCurrent();
      const user = UserService.getCurrent();

      /**
       * We need to check if the current user is a SRP only user, if they are,
       * show them this page which forces them to navigate to the SRP or pick a
       * different org that they have more access with.
       */
      if (
        user &&
        user.permission_group.is_service_request_portal &&
        toState.name !== "srpRedirect"
      ) {
        return $state.go("srpRedirect");
      }

      // Set Google Tracker page and send page view to Analytics if we're in prod
      var urlPath = $state.href(toState, toParams, { absolute: true });
      ShadowService.setPage(urlPath, "Mobile " + pageTitle);
      ShadowService.setOrganization(organization);

      if (toParams.buildingId) {
        var cachedBuildings = FilterService.getCachedBuildingIds();
        if (
          cachedBuildings.length &&
          cachedBuildings.indexOf(toParams.buildingId) === -1
        ) {
          // clear cached building filters if user changed buildings
          for (var i = 0; i < cachedBuildings.length; i++) {
            FilterService.clearBuildingFilters(cachedBuildings[i]);
          }
        }
      }

      if (toState.data) {
        $rootScope.noToolbar = toState.data.noToolbar
          ? toState.data.noToolbar
          : false;
      } else {
        $rootScope.noToolbar = false;
        $rootScope.parent = null;
      }

      $rootScope.session = {
        organization: organization,
        building: building,
      };

      hideProgressBar();
    }

    function showProgressBar() {
      $rootScope.showProgressBar = true;
    }

    function hideProgressBar() {
      $timeout(function () {
        $rootScope.showProgressBar = false;
        $rootScope.$broadcast("abxHideProgressBar");
      }, 300);
    }
  }

  function getStates() {
    return [
      {
        state: "app",
        config: {
          abstract: true,
          url: "/m",
          templateUrl: "app/mobile/mobile.html",
          controller: "MobileController",
          controllerAs: "vm",
          resolve: {
            account: getIdentity,
            organization: getOrganization,
            user: getUser,
          },
        },
      },
    ];
  }

  /* @ngInject */
  function getIdentity(IdentityService, $state, $q) {
    return IdentityService.getCurrent().catch(function (err) {
      // If we catch an error because the server can't be reached, show the 503 page
      if (err.status === -1) {
        $state.go("root.503");
      }

      return $q.reject(err);
    });
  }

  /**
   * Get the user's current organization
   *
   * @param $location
   * @param account               Depends on account
   * @param OrganizationService
   *
   * @ngInject
   */
  function getOrganization(
    $location,
    account, // Needs to wait for account to be resolved
    OrganizationService
  ) {
    var current = OrganizationService.getCurrent();
    if (current) {
      return current;
    }
    return OrganizationService.init($location.path());
  }

  /**
   * Get current user of organization
   *
   * @param organization
   * @param UserService
   *
   * @return {Object} User of organization
   *
   * @ngInject
   */
  function getUser(organization, UserService) {
    if (organization) {
      return UserService.init(organization._id);
    }
    return null;
  }
})();
